import { AuthenticationService, Tag } from 'bandon-shared';
import { Component } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from 'src/environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { LoadingTemplateComponent } from 'src/app/components/ModalTemplates/loading-template/loading-template.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { NgFor } from '@angular/common';
import { MatListModule } from '@angular/material/list';
import { MainMenuComponent } from '../../../components/navigation/main-menu/main-menu.component';

@Component({
    selector: 'app-tags-list',
    templateUrl: './tags-list.component.html',
    styleUrls: ['./tags-list.component.scss'],
    standalone: true,
    imports: [MainMenuComponent, MatListModule, NgFor, MatFormFieldModule, MatInputModule, MatButtonModule, MatIconModule]
})
export class TagsListComponent {
  public tags: Tag[] = [];
  private unsubscribe$ = new Subject<void>();

  constructor(
    private httpClient: HttpClient,
    private authService: AuthenticationService,
    private _snackBar: MatSnackBar,
    private dialog: MatDialog
  ) {
  }

  ngOnInit(): void {
    this.updateTagsList();
  }

  private updateTagsList(): void {
    //Get all Tunes
    const loadingDialog = this.dialog.open(LoadingTemplateComponent)
    const headers = new HttpHeaders().set('Authorization', this.authService.getIDToken());

    this.httpClient.get<Tag[]>(environment.apiURL+"/tags", {headers})
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        (tags) => {
          this.tags.length = 0;
          this.tags.push(...tags);
          loadingDialog.close();
        }
      );
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  addTag() {
    const data = {
      designation: ''
    };

    const headers = new HttpHeaders().set('Authorization', this.authService.getIDToken());
    this.httpClient.put(environment.apiURL+`/tags`, data, {headers})
    .subscribe(res => {
      console.log(res);
      this.updateTagsList();
    });

  }

  changeTag(tag: Tag, event: any): void {
    if(event.target.value) {
      const data = {
        designation: event.target.value
      };

      const headers = new HttpHeaders().set('Authorization', this.authService.getIDToken());
      this.httpClient.post(environment.apiURL+`/tags/${tag.id}`, data, {headers})
      .subscribe(res => {
        this._snackBar.open('Tag wurde angepasst', 'ok')
      });
    }
  }

  deleteTag(tag: Tag) {
    const headers = new HttpHeaders().set('Authorization', this.authService.getIDToken());
    this.httpClient.delete(environment.apiURL+`/tags/${tag.id}`, {headers})
    .subscribe({
      next: (resp) => {
        this._snackBar.open('Tag wurde gelöscht', 'ok')
        this.updateTagsList();
      },
      error: (error) => {
        this._snackBar.open('Tag konnte nicht gelöscht werden. Vermutlich wird er bei Stücken verwendet.', 'ok')
      }
    });
  }
}
